export const mozAppsEvents = {
  INSTALL: 'install',
  UNINSTALL: 'uninstall',
  UPDATE: 'update'
};

export const mozAppEvent = {
  ON_DOWNLOAD_APPLIED: 'ondownloadapplied',
  ON_DOWNLOAD_ERROR: 'ondownloaderror',
  ON_PROGRESS: 'onprogress',
  ON_DOWNLOAD_AVAILABLE: 'ondownloadavailable',
  ON_DOWNLOAD_SUCCESS: 'ondownloadsuccess'
};

export const accountEvent = {
  ON_ACCOUNT_API_MISSING: 'missing',
  ON_LOGIN: 'login',
  ON_LOGOUT: 'logout',
  ON_READY: 'ready',
  ON_ERROR: 'error'
};

export const tokenType = {
  RESTRICTED: 0,
  ACCOUNT: 1
};

export const validFeature = {
  HAS_WIFI: 'device.capability.wifi',
  IS_WIFI_CERTIFIED: 'device.capability.wifi.wifi_certified',
}

export const validSettingKey = {
  AUTO_DOWNLOAD: 'app.update.auto-download',
  RICH_CONTENT: 'store.richcontent.mode',
};

export const validSettingData = {
  [validSettingKey.AUTO_DOWNLOAD]: {
    default: 'data-enable',
    values: ['auto-update-off', 'data-enable', 'wifi-only']
  },
  [validSettingKey.RICH_CONTENT]: {
    default: 'wifi-only',
    values: ['do-not-show', 'data-enable', 'wifi-only']
  }
};

export const validStorageSections = {
  INSTALL: 'install',
  UPDATE: 'update'
};

export const internalApps = {
  PAYMENT: 'UgW01f5JflryQMM4H7SF',
  FIH_HMD: 'mpEy1f2paIZOdwYMzzr6',
  STORE: 'daR-aFQOTlGk8DJePIQA',
  EVENT_LOGGER: 'qli0T1E695LxmxEqZer4'
};
